import angular from 'angular'
import templateUrl from './edit-division.component.html'
import { EditDivisionProfilePayrollPolicyHistoryModal } from '../edit-division-profile-payroll-policy-history/edit-division-profile-payroll-policy-history-modal.component';

export const EditDivisionComponent = {
    templateUrl,
    controller: EditDivisionController,
    controllerAs: "vm",
    require: {
        editForm: "?^^form"
    },
    bindings: {
        division: "<",
        countries: "<",
        rotationLengthTypes: "<",
        payrollTypes: "<",
        payrollInvoicePolicies: "<",
        save: "&onSave"
    }
}

function EditDivisionController($uibModal, onboardingPolicyService, utilityService) {
    'ngInject'
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.addDivisionProfile = addDivisionProfile;
    vm.division;
    vm.removeDivisionProfile = removeDivisionProfile;
    vm.rotationLengthTypes;
    vm.onAddOnboardingPolicy = onAddOnboardingPolicy;
    vm.onAddOnboardingPolicyAsCopy = onAddOnboardingPolicyAsCopy;
    vm.onRemoveOnboardingPolicy = onRemoveOnboardingPolicy;

    vm.hasAnyProfileModification = hasAnyProfileModification;
    vm.onSelectDivisionProfile = onSelectDivisionProfile;
    vm.pristineDivisionProfiles = [];
    vm.$onChanges = onChanges;
    vm.$onInit = function () {
        if (vm.division) {
            vm.pristineDivisionProfiles = vm.division.DivisionProfiles.map(p => p.DivisionProfileID);
        }
    };

    function addDivisionProfile() {
        const divisionProfile = {
            Name: "New Profile",
            RotationPolicy: {
                // Leave as divisional defaults.
                RotationLengthType: null,
                RotationLength: null
            },
            PayrollPolicyHistory: [],
            CommissionPolicy: {},
            PayrollInvoicePolicy: null,
            NextRotation: {
                StartDate: null,
                EndDate: null
            }
        };

        const unusedCountry = vm.countries.filter(function (country) {
            // Pick the default name of the profile to be the first country that
            // isn't already used as the name of a profile.
            return vm.division.DivisionProfiles.filter(function (profile) {
                return profile.Name === country.CountryName;
            }).length === 0;
        })[0];
        if (unusedCountry) {
            divisionProfile.Name = unusedCountry.CountryName;
        }

        vm.division.DivisionProfiles.push(divisionProfile);

        vm.selectedDivisionProfile = divisionProfile;

        // This won't actually constitute a change in the ng-form, so set the form dirty manually.
        if (vm.editForm) {
            vm.editForm.$setDirty(true);
        }
    }

    function removeDivisionProfile(divisionProfile) {
        vm.division.DivisionProfiles = vm.division.DivisionProfiles.filter(function (profile) {
            return profile !== divisionProfile;
        });
        if (vm.editForm) {
            vm.editForm.$setDirty(true);
        }

        vm.selectedDivisionProfile = null;
    }

    function onChanges(change) {

        if (change.division.currentValue && !change.division.isFirstChange()) {
            /*As we are restricting the user to only create one division profile at a time
            So this wouldnt be greater than one (i.e there would be only one value if there is a
            new profile added otherwise in case of update it would be zero)*/
            const newlyCreatedDivisionProfile = change.division.currentValue.DivisionProfiles
                .some(function (profile) {
                    return vm.pristineDivisionProfiles.filter(p => p === profile.DivisionProfileID)[0] == null;
                });
            vm.pristineDivisionProfiles = change.division.currentValue.DivisionProfiles.map(p => p.DivisionProfileID);
            vm.selectedDivisionProfile = newlyCreatedDivisionProfile;
            if (newlyCreatedDivisionProfile) {
                onEditPayrollPolicyHistory(newlyCreatedDivisionProfile)
            }
        }
    }

    function onSelectDivisionProfile(profile) {
        if (vm.selectedDivisionProfile !== profile) {
            //If there is a change
            const errorMsg = "Switching between profiles is not allowed until the current profile is saved.";

            const targetProfileInvalid = profile ? profile.editForm && profile.editForm.$invalid
                : vm.divisionDefaultPoliciesForm && vm.divisionDefaultPoliciesForm.$invalid;
            //If Default is selected
            if (vm.selectedDivisionProfile == null) {
                // Switching from the default profile page. Prevent the the change if the specific form is invalid,
                // unless the target profile is also invalid.
                if (!targetProfileInvalid && vm.divisionDefaultPoliciesForm && vm.divisionDefaultPoliciesForm.$dirty) {
                    alert(errorMsg);
                    return;
                }
            } else if (!targetProfileInvalid && (
                vm.selectedDivisionProfile.DivisionProfileID == null
                || vm.selectedDivisionProfile.editForm && vm.selectedDivisionProfile.editForm.$dirty)) {
                alert(errorMsg);
                return;
            }

            vm.selectedDivisionProfile = profile;
        }
    }

    function hasAnyProfileModification() {
        return vm.division.DivisionProfiles.some(function (profile) {
            return profile.DivisionProfileID == null || profile.editForm && profile.editForm.$dirty;
        });
    }

    function onAddOnboardingPolicy() {
        const onboardingPolicy = {
            ContactEmails: [],
            ApplicationStatuses: [],
            ReferenceFields: [],
            OnboardingDocumentGroups: [],
            OnboardingDocuments: []
        };

        editOnboardingPolicyInModal(onboardingPolicy);
    }

    function onRemoveOnboardingPolicy() {
        if (!confirm("Danger! If you confirm, the policy will be deleted. Existing onboarding applications will not be affected, but if you add back the policy later, be aware that changes will no longer be reflected on old applications.")) {
            return;
        }
        const onboardingPolicyRemoved = onboardingPolicyService.removeDivisionOnboardingPolicy(vm.division.DivisionID)
            .then(function () {
                vm.division.OnboardingPolicyID = null;
                vm.division.OnboardingPolicy = null;
            });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(onboardingPolicyRemoved, "Deleting onboarding policy failed"));
    }

    function onAddOnboardingPolicyAsCopy() {
        onboardingPolicyService.retrieveOnboardingPolicy(vm.division.OnboardingPolicyID)
            .then(function (policy) {
                editOnboardingPolicyInModal(policy);
            });
    }

    function onEditPayrollPolicyHistory(divisionProfile) {
        $uibModal.open({
            ...EditDivisionProfilePayrollPolicyHistoryModal,
            resolve: {
                divisionProfile: function () {
                    // Create a clone of the payroll policy history to be edited in the modal.
                    return {
                        DivisionProfileID: divisionProfile.DivisionProfileID,
                        Name: divisionProfile.Name,
                        PayrollPolicyHistory: angular.copy(divisionProfile.PayrollPolicyHistory)
                    };
                }
            }
        }).result.then(function (payrollPolicyHistory) {
            divisionProfile.PayrollPolicyHistory = payrollPolicyHistory;
        }, () => { });
    }

    function editOnboardingPolicyInModal(onboardingPolicy) {
        $uibModal.open({
            component: "apexEditDivisionOnboardingPolicyModal",
            resolve: {
                division: function () {
                    return vm.division;
                },
                onboardingPolicy: function () {
                    return onboardingPolicy;
                }
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'xl',
            backdrop: 'static'
        }).result.then(function (onboardingPolicy) {
            vm.division.OnboardingPolicy = onboardingPolicy;
            vm.division.OnboardingPolicyID = onboardingPolicy.OnboardingPolicyID;
        });
    }
}
